import { Input_Icon_default } from "./chunk-FR2L3QT2.js";
import { Input_Input_default } from "./chunk-KR2DFR5I.js";
import { Input_default } from "./chunk-U57ML2QY.js";

// src/elements/Input/index.ts
var InputComponent = Input_default;
InputComponent.Icon = Input_Icon_default;
InputComponent.Icon.displayName = "Input.Icon";
InputComponent.Input = Input_Input_default;
InputComponent.Input.displayName = "Input.Input";
export { InputComponent };